<script>
// Importing Bar class from the vue-chartjs wrapper
import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

// Exporting this so it can be used in other components
export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // renderChart function renders the chart with the datacollection and options object.
    this.renderChart(this.chartData, this.options)
  }
}
</script>
